export default __webpack_public_path__ + "static/media/staff_of_homa.b8d62b3c.png";